import { render, staticRenderFns } from "./TreeNodeManagement.vue?vue&type=template&id=2130a512&scoped=true"
import script from "./TreeNodeManagement.vue?vue&type=script&lang=js"
export * from "./TreeNodeManagement.vue?vue&type=script&lang=js"
import style0 from "./TreeNodeManagement.vue?vue&type=style&index=0&id=2130a512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2130a512",
  null
  
)

export default component.exports